module.exports = __webpack_public_path__ + "img/01-Livepen-BT-PD01.f00ddd22.png";